import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';

import { AuthenticationService } from './_services';
import { User } from './_models';
import { AiDialogComponent } from './_components/ai/ai-dialog/ai-dialog.component';
import { environment } from '../environments/environment';
import { NAV_ROUTES, NavRoute } from './route-registry';

@Component({
	standalone: false,
	selector: 'app-base',
	templateUrl: 'app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit
{
	@ViewChild('aiWidget') aiWidget!: AiDialogComponent;

	currentUser: User;
	currentUserRoles: any[] = [];

	navSearch: any;
	filteredNavItems: NavRoute[] = [];

	/* ── Mobile nav drawer state ─────────────────────────────────────────── */
	mobileNavOpen = false;
	mobileOpenSections = new Set<string>();

	readonly navItems: NavRoute[] = NAV_ROUTES;

	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private primengConfig: PrimeNGConfig
	)
	{
	this.authenticationService.currentUser.subscribe(currentUser => {
		this.currentUserRoles = [];
		if (currentUser && currentUser.userRoles) {
			for (let i = 0; i < currentUser.userRoles.length; i++) {
				this.currentUserRoles.push(currentUser.userRoles[i].userRoleId);
			}
			this.currentUser = currentUser;
		} else {
			this.currentUser = null;
		}
		});
	}

	ngOnInit()
	{
		this.primengConfig.ripple = true;
		// Ensure overlay components like calendar appear above dialogs
		this.primengConfig.zIndex = {
			modal: 11000,
			overlay: 11040,
			menu: 11060,
			tooltip: 11080
		};
	}

	searchNav(event: any): void
	{
		const q = event.query.toLowerCase();
		this.filteredNavItems = this.navItems.filter(item =>
			item.label.toLowerCase().includes(q) || item.route.toLowerCase().includes(q)
		);
	}

	onNavSelect(event: any): void
	{
		const item = event.value ?? event;
		this.navSearch = null;
		this.router.navigateByUrl(item.route);
	}

	openTripPlanner(): void
	{
		window.open(`${environment.kbmResortsURL}?tripPlanner=open`, '_blank');
	}

	toggleAiWidget(): void
	{
		this.aiWidget.toggle();
	}

	/** Open / close the whole drawer */
	toggleMobileNav(): void {
		this.mobileNavOpen = !this.mobileNavOpen;
		if (!this.mobileNavOpen) { this.mobileOpenSections.clear(); }
	}

	/** Expand or collapse an accordion section by key */
	toggleMobileSection(s: string): void {
		if (this.mobileOpenSections.has(s)) {
			this.mobileOpenSections.delete(s);
		} else {
			this.mobileOpenSections.add(s);
		}
	}

	/** Close the drawer and navigate (called from every nav link) */
	closeMobileNav(): void {
		this.mobileNavOpen = false;
		this.mobileOpenSections.clear();
	}

	logout()
	{
		this.authenticationService.logout();
		this.currentUserRoles = [];
		this.router.navigate(['/login']);
	}
}
